__turbopack_context__.v({
  "cms-page": "Cms-module-scss-module__FZJlca__cms-page",
  "main": "Cms-module-scss-module__FZJlca__main",
});
